module.exports = __webpack_public_path__ + "static/media/scheduler_media_carousel.fe8d596a.xlsx";